module.exports = __webpack_public_path__ + "img/glenn-carstens-peters.29cd9d7b.jpg";